import { createSlice } from "@reduxjs/toolkit";
import { getUser } from "../thunks/userThunk";
import { IAuthState } from "../types/user-types";

const initialState: IAuthState = {
  user: null,
  me: null,
  unreadInboxCount: 0,
  loading: false,
  error: null,
  currentTokenBalance: null,
  hasSpecification: false,
  otpStartTime: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearUser: (state) => {
      state.user = null;
      state.currentTokenBalance = null;
      state.otpStartTime = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setMe: (state, action) => {
      state.me = action.payload;
      state.currentTokenBalance = action.payload?.prtToken;
    },
    setHasSpecification: (state, action) => {
      state.hasSpecification = action.payload;
    },
    setUnreadInboxCount: (state, action) => {
      state.unreadInboxCount = action.payload;
    },
    setCurrentTokenBalance: (state, action) => {
      state.currentTokenBalance = action.payload;
    },
    setOtpStartTime: (state, action) => {
      state.otpStartTime = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(getUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setUser,
  clearUser,
  setLoading,
  setError,
  setMe,
  setUnreadInboxCount,
  setCurrentTokenBalance,
  setHasSpecification,
  setOtpStartTime,
} = userSlice.actions;
export default userSlice.reducer;
